import React from "react";
import LogoWhite from "../../assets/Logo White.svg";

const mainLinks = {
    Documentation: "https://docs.steinhq.com",
    Pricing: "https://steinhq.com/pricing",
    "Open Source": "https://github.com/SteinHQ",
    Contact: "mailto:hello@steinhq.com"
  },
  secondaryLinks = {
    "Privacy Policy": "https://steinhq.com/privacy-policy",
    "Terms of Service": "https://steinhq.com/terms-of-service"
  };

const mainLinkElements = [],
  secondaryLinkElements = [];

function generateLinkElement(name, value, classes) {
  return (
    <a className={classes} href={value} key={name}>
      {name}
    </a>
  );
}

Object.keys(mainLinks).forEach(name => {
  mainLinkElements.push(
    generateLinkElement(
      name,
      mainLinks[name],
      "text-white mr-5 animated-text-link"
    )
  );
});

Object.keys(secondaryLinks).forEach(name => {
  secondaryLinkElements.push(
    generateLinkElement(
      name,
      secondaryLinks[name],
      "text-greengreytext mr-5 animated-text-link text-sm"
    )
  );
});

const Footer = () => {
  return (
    <>
      <div className="bg-primary pt-12 pb-4 px-8 sm:px-16 md:px-20 mt-16 pin-b w-full">
        <img src={LogoWhite} alt="Stein Logo" className="h-8" />
        <div className="mt-5 leading-loose sm:leading-normal">
          {mainLinkElements}
        </div>
        <hr className="border-t border-white mt-6 opacity-25" />
        <div className="mt-3">{secondaryLinkElements}</div>
        <div className="mt-3 text-greengreytext text-sm">
          © {new Date().getFullYear()} Stein
        </div>
      </div>
    </>
  );
};

export default Footer;
